import { jsx as l } from "react/jsx-runtime";
const o = (c) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...c,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "#FFD000",
        fillRule: "evenodd",
        d: "M5.72 20.215 2.514 21.6c-.115-3.399-.3-6.803-.34-10.204l.012-.646c.024-1.128.061-2.139.106-2.842.197-2.34 2.033-4.079 4.263-4.28a71 71 0 0 1 4.941-.199l.507-.001c1.836 0 3.738.067 5.443.2q.431.04.838.152l3.2-1.38.338 8.679.002.11v1.673l-.013.64a71 71 0 0 1-.102 2.642c-.196 2.34-2.033 4.079-4.263 4.28a71 71 0 0 1-4.941.198l-.507.002c-1.836 0-3.439-.068-5.13-.201-.371-.034-.806-.093-1.15-.208m6.282-2.868.6-.003.58-.008a66 66 0 0 0 4.003-.19c.721-.066 1.246-.601 1.312-1.27l.022-.24c.06-.714.1-1.717.122-2.818v-1.584l-.014-.604a37 37 0 0 0-.13-2.455c-.066-.668-.59-1.203-1.312-1.27a67 67 0 0 0-4.003-.19l-.58-.008-.64-.002-.56.002c-1.55.015-3.092.08-4.584.198-.721.067-1.246.602-1.311 1.27l-.023.24c-.074.875-.116 2.181-.135 3.572l.013.83.014.605c.028.985.07 1.854.13 2.454.066.67.59 1.204 1.312 1.27 1.306.103 2.65.166 4.003.19l.58.008z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  o as default
};
